import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import BookingSection from "@/components/BookingSection";
import Gallery from "@/components/Gallery";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="min-h-screen bg-[#FAF9F6] text-[#1A1A1A]">
      <Header />
      <Hero />
      <About />
      <Services />
      <BookingSection />
      <Gallery />
      <ContactSection />
      <Footer />
    </main>
  );
}
